/**
 * Store: Shop the look
 * -----------------------------------------------------------------------------
 * Handles Shop the look actions
 */

export default {
  namespaced: true,

  state: () => ({
    selectedProducts: false,
    sectionLocation: false,
    blockConfigs: false,
    index: false,
  }),

  getters: {

    /**
     * Get the current active products for STL modal
     * @returns {Object}
     */
    getCurrentProducts(state) {
      return state.products
    },
  },

  mutations: {

    /**
     * Set product.
     */
    SET_PRODUCTS(state, products) {
      state.selectedProducts = products
    },

    /**
     * Set location.
     */
    SET_LOCATION(state, location) {
      state.sectionLocation = location
    },

    SET_BLOCK_CONFIGS(state, blockConfigs) {
      state.blockConfigs = blockConfigs
    },

    SET_INDEX(state, index) {
      state.index = index
    },
  },

  actions: {

    /**
      * Set products data.
      * @param {Array} products - Product array.
      */
    setProducts({ commit }, products = false) {
      commit('SET_PRODUCTS', products)
    },

    /**
      * Set location (page & metaobject name).
      * @param {Object} location.
      */
    setLocation({ commit }, location = false) {
      commit('SET_LOCATION', location)
    },

    setBlockConfigs({ commit }, blockConfigs = false) {
      commit('SET_BLOCK_CONFIGS', blockConfigs)
    },

    setIndex({ commit }, index = false) {
      commit('SET_INDEX', index)
    },
  },
}
